import { Box, Card, Divider, Icon, Text } from '@chakra-ui/react';

const SectionCard = ({ title, icon, children }: { title: string; icon: any; children: React.ReactNode }) => (
  <Card
    flexDirection="column"
    w="100%"
    p={5}
    boxShadow="sm"
    transition="all 0.2s"
    _hover={{ boxShadow: 'md' }}
  >
    <Box
      display="flex"
      alignItems="center"
      mb={3}
    >
      <Icon
        as={icon}
        fontSize="24px"
        mr={2}
        color="blue.500"
      />
      <Text fontWeight="bold">{title}</Text>
    </Box>
    <Divider mb={3} />
    {children}
  </Card>
);

export default SectionCard;
